<div class="section pre-footer-section" [class.dark]="dark" [class.black]="black">
  @defer (on viewport) {
    <div class="pre-footer-blur"></div>
  } @placeholder {
    <div></div>
  } @error {
    <div></div>
  }
  <div class="pre-footer" [class.color-dark]="dark">
    <div class="pre-footer-title">{{ title }}</div>
    <div class="cta">
      <ng-content></ng-content>
    </div>
    <app-picture
      [url]="dark ? darkImage || defaultDarkImage : lightImage || defaultLightImage"
      [width]="dark ? 1844 : 1920"
      [height]="dark ? 802 : 884"
      [maxWidth]="980"
      [scale]="1"
    ></app-picture>
    <div class="image-shadow"></div>
  </div>
</div>
